import { render, staticRenderFns } from "./AddBankerModal.vue?vue&type=template&id=2fe5512c"
import script from "./AddBankerModal.vue?vue&type=script&lang=js"
export * from "./AddBankerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports